"use strict";

var _classCallCheck = require("/tmp/build_afa5e9373483510c3650f3d80edeec0c/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/build_afa5e9373483510c3650f3d80edeec0c/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/tmp/build_afa5e9373483510c3650f3d80edeec0c/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/tmp/build_afa5e9373483510c3650f3d80edeec0c/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/tmp/build_afa5e9373483510c3650f3d80edeec0c/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var HTMLCollection = require("../generated/HTMLCollection");

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var DefaultConstraintValidationImpl = require("../constraint-validation/DefaultConstraintValidation-impl").implementation;

var _require = require("../helpers/form-controls"),
    formOwner = _require.formOwner;

var _require2 = require("../../utils"),
    mixin = _require2.mixin;

var _require3 = require("../helpers/traversal"),
    descendantsByLocalNames = _require3.descendantsByLocalNames;

var listedElements = new Set(["button", "fieldset", "input", "object", "output", "select", "textarea"]);

var HTMLFieldSetElementImpl =
/*#__PURE__*/
function (_HTMLElementImpl) {
  _inherits(HTMLFieldSetElementImpl, _HTMLElementImpl);

  function HTMLFieldSetElementImpl(args, privateData) {
    var _this;

    _classCallCheck(this, HTMLFieldSetElementImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HTMLFieldSetElementImpl).call(this, args, privateData));
    _this._customValidityErrorMessage = "";
    return _this;
  }

  _createClass(HTMLFieldSetElementImpl, [{
    key: "_barredFromConstraintValidationSpecialization",
    value: function _barredFromConstraintValidationSpecialization() {
      return true;
    }
  }, {
    key: "elements",
    get: function get() {
      var _this2 = this;

      return HTMLCollection.createImpl([], {
        element: this,
        query: function query() {
          return descendantsByLocalNames(_this2, listedElements);
        }
      });
    }
  }, {
    key: "form",
    get: function get() {
      return formOwner(this);
    }
  }, {
    key: "type",
    get: function get() {
      return "fieldset";
    }
  }]);

  return HTMLFieldSetElementImpl;
}(HTMLElementImpl);

mixin(HTMLFieldSetElementImpl.prototype, DefaultConstraintValidationImpl.prototype);
module.exports = {
  implementation: HTMLFieldSetElementImpl
};